module.exports = __webpack_public_path__ + "static/media/search-illustration.cfcb4e1c.svg";